import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { ThreeBounce } from 'better-react-spinkit'

import futureElectionFormContainer from './futureElectionFormContainer'
import './FutureElectionForm.css'

let FutureElectionForm = ({
  busy,
  handleSubmit,
  submitting,
  customerRecruitmentQuestions
}) => (
  <form onSubmit={handleSubmit} className="mb-4 mt-4 FutureElectionForm">
    <div className="form-group">
      <label htmlFor="first_name">First name</label>
      <Field
        className="form-control form-control-lg"
        component="input"
        id="first_name"
        name="first_name"
        required
        type="text"
      />
    </div>
    <div className="form-group">
      <label htmlFor="last_name">Last name</label>
      <Field
        className="form-control form-control-lg"
        component="input"
        id="last_name"
        name="last_name"
        required
        type="text"
      />
    </div>
    <div className="form-group">
      <label htmlFor="email">Email address</label>
      <Field
        className="form-control form-control-lg"
        component="input"
        id="email"
        name="email"
        placeholder="you@example.com"
        required
        type="email"
      />
    </div>

    {/* START ohiodems custom fields */}
    <div className="form-group">
      <label htmlFor="phone">Phone number</label>
      <Field
        className="form-control form-control-lg"
        component="input"
        id="phone"
        name="phone"
        placeholder="(123) 456-7890"
        type="phone"
      />
    </div>
    <div className="form-group">
      <label htmlFor="your_story">What's your story?</label>
      <Field
        className="form-control form-control-lg"
        component="textarea"
        id="your_story"
        name="your_story"
      />
    </div>
    {/* END ohiodems custom fields */}

    {/* customer custom fields */}
    {customerRecruitmentQuestions.map((field, i) => (
      field.type === 'dropdown' ?
          (
              <div className="form-group" key={`custom-question-${i}`}>
                  <label htmlFor={`custom-question-${i}`}>{field.question}</label>
                  <Field
                      className="form-control form-control-lg"
                      component="select"
                      id={`custom-question-${i}`}
                      name={`custom-question-${i}`}
                      required={!field.isOptional}
                  >
                      <option></option>
                      {field.answers.map((answer, optionId) => (
                          <option key={optionId}>
                              {answer}
                          </option>
                      ))}
                  </Field>
              </div>
          ) :
          field.type === 'checkbox' ?
              (
                  <div className="form-group" key={`custom-question-${i}`}>
                      <label htmlFor={`custom-question-${i}`}>{field.question}</label>
                      {field.answers.map((answer, optionId) => (
                          <div className="custom-checkbox" key={`custom-question-${i}-${optionId}`}>
                              <Field
                                  className="form-check-input"
                                  component="input"
                                  type="checkbox"
                                  id={`custom-question-${i}-${optionId}`}
                                  name={`custom-question-${i}[${optionId}]`}
                                  value={answer}
                                  parse={isSelected => isSelected ? answer: null}
                              />
                              <label class="form-check-label" htmlFor={`custom-question-${i}-${optionId}`}>{answer}</label>
                          </div>
                      ))}
                  </div>
              ) :
              /* field.type is 'text' */
              (
                  <div className="form-group" key={`custom-question-${i}`}>
                      <label htmlFor={`custom-question-${i}`}>{field.question}</label>
                      <Field
                          className="form-control form-control-lg"
                          component="textarea"
                          id={`custom-question-${i}`}
                          name={`custom-question-${i}`}
                          required={!field.isOptional}
                      />
                  </div>
              )
    ))}

    <button
      className="btn btn-lg btn-block btn-primary"
      disabled={busy || submitting}
      type="submit"
    >
      {(busy || submitting) ? <ThreeBounce color='#fff' size={12} /> : 'Submit'}
    </button>
  </form>
)

export default futureElectionFormContainer(
  reduxForm({ form: 'futureElectionForm' })(FutureElectionForm)
)


// WEBPACK FOOTER //
// ./src/components/FutureElectionScene/FutureElectionForm/FutureElectionForm.js